import { useSyncExternalStore } from 'react';

function subscribe(callback: () => void): () => void {
  document.addEventListener('visibilitychange', callback);
  return () => document.removeEventListener('visibilitychange', callback);
}

function getSnapshot(): boolean {
  return document.visibilityState === 'visible';
}

function getServerSnapshot(): boolean {
  return true;
}

/**
 * Returns a `refetchInterval` value that pauses polling when the browser tab
 * is hidden. Uses the Page Visibility API via `useSyncExternalStore`.
 *
 * - Visible → returns `intervalMs`
 * - Hidden  → returns `false` (disables TanStack Query polling)
 * - SSR     → returns `intervalMs` (fail-open)
 */
export function useVisibilityPolling(intervalMs: number | false): number | false {
  const isVisible = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

  if (intervalMs === false) return false;
  return isVisible ? intervalMs : false;
}
